const sizes = {
  maxWidth: 1080,
}

export default sizes
